var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("content-container", { attrs: { showCastle: true } }, [
    _c(
      "div",
      { staticClass: "home-container" },
      [
        _c("div", [
          _c("div", { staticClass: "pre-header" }, [_vm._v("Select Your")]),
          _vm._v(" "),
          _c("div", { staticClass: "main-header" }, [_vm._v("Hogwarts")]),
          _vm._v(" "),
          _c("div", { staticClass: "main-header" }, [_vm._v("House")])
        ]),
        _vm._v(" "),
        _c("separator", { attrs: { big: "true" } }),
        _vm._v(" "),
        _vm.tokenValid
          ? _c(
              "div",
              { staticClass: "button-container" },
              [
                _c(
                  "router-link",
                  { staticClass: "btn", attrs: { to: "/form" } },
                  [_vm._v("Continue")]
                )
              ],
              1
            )
          : _c("div", [
              _c("div", { staticClass: "page-expired" }, [
                _vm._v(_vm._s(_vm.expiredMessage))
              ]),
              _vm._v(" "),
              _c("div", [_vm._v("Please re-scan the QR code")])
            ])
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }